import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { statusStyles } from './Orders';
import { apiFetch, formatDate } from '../../utils/api';

const OrderDetails = () => {
    const { id } = useParams(); // from /myaccount/orders/:id
    const [order, setOrder] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let cancelled = false;
        setLoading(true);
        apiFetch(`/orders/${id}`)
            .then(({ ok, data }) => {
                if (!cancelled) setOrder(ok ? data : null);
            })
            .finally(() => {
                if (!cancelled) setLoading(false);
            });
        return () => {
            cancelled = true;
        };
    }, [id]);

    if (loading) return null;

    if (!order) {
        return (
            <>
                <p className="text-sm text-gray-600">Order not found.</p>
                <Link to="/myaccount/orders" className="text-sm font-semibold text-[#2f6b1f] hover:underline">Back to orders</Link>
            </>
        );
    }

    const itemCount = order.items.reduce((sum, i) => sum + i.quantity, 0);

    return (
        <>
            <Link to="/myaccount/orders" className="text-sm text-[#2f6b1f] hover:underline">‹ Back to orders</Link>
            <div className="mt-3 rounded-xl border border-gray-200 bg-white p-6 shadow-sm">
                <div className="flex items-start justify-between">
                    <div>
                        <h1 className="text-xl font-semibold">Order #{order.orderNo}</h1>
                        <p className="mt-1 text-sm text-gray-500">Placed on {formatDate(order.createdAt)} • {itemCount} items</p>
                    </div>
                    <span className={`rounded-md px-3 py-1.5 text-xs font-semibold ${statusStyles[order.status]}`}>{order.status}</span>
                </div>
                <div className="mt-6 flex justify-between border-t border-gray-100 pt-4 text-sm">
                    <span className="text-gray-600">Total</span>
                    <span className="font-semibold">₹{order.total.toLocaleString('en-IN')}</span>
                </div>
            </div>
        </>
    );
};

export default OrderDetails;
